import * as React from 'react';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import { getOfficeStaff } from 'redux/modules/shop/shopcard';
import { IStore } from 'redux/IStore';
import { IShopCardData } from 'models/shop/shopcard';
import { IOfficesAction } from 'models/shop/office';
import { ItemCardList, Button } from 'components';
import { IItemCardList } from 'models/itemcard';
import { IOfficeMember } from 'models/shop/members';
import { editMember } from 'redux/modules/shop/helpers';
import { actions as notifActions } from 'redux-notifications';
import { closeModal, showModal } from 'redux/modules/modal';
import { browserHistory } from 'react-router';
import { IImageData } from 'models/common';
import { cropAndSaveFormImage } from 'redux/modules/image';
const { connect } = require('react-redux');

export interface IUserAbout {
	about: string;
}

interface IProps {
	officeId: string;
	canEdit?: boolean;
	shopcard?: IShopCardData;
	t?: any;
	getOfficeStaff?: (officeId: string) => IOfficesAction;
	editMember?: (member: IOfficeMember, success, error) => any;
	showNotification?: (message: string, kind: string, dismissAfter?: number) => any;
	closeModal?: () => any;
	showModal?: (modalType: string, modalProps: any) => any;
	cropAndSaveFormImage?: (image: IImageData) => Promise<any>;
}

@connect(
	(state: IStore) => ({
		shopcard: state.shopcard,
	}),
	(dispatch) => ({
		getOfficeStaff: (officeId) => dispatch(getOfficeStaff(officeId)),
		editMember: (member: IOfficeMember, success, error) =>
			dispatch((_dispatch, getState: () => IStore) => editMember(getState, member).then(success).catch(error)),
		showNotification: (message: string, kind: string, dismissAfter = 3000) =>
			dispatch(notifActions.notifSend({ message, kind, dismissAfter })),
		closeModal: () => dispatch(closeModal()),
		showModal: (modalType: string, modalProps: any) => dispatch(showModal(modalType, modalProps)),
		cropAndSaveFormImage: (image: IImageData) => dispatch(cropAndSaveFormImage(image)),
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ShopStaffMembers extends React.Component<IProps, any> {
	constructor(props) {
		super(props);

		this.getStaffMembers = this.getStaffMembers.bind(this);
		this.handleEditClick = this.handleEditClick.bind(this);

		this.state = {
			/**
			 * when staff member data has been chainged, to prevent the need for refresh
			 */
			newStaffMemberData: {},
		};
	}

	private getStaffMembers() {
		if (
			this.props.officeId &&
			!this.state[this.props.officeId] &&
			!this.props.shopcard.shopcard?.offices.find((office) => office.id == this.props.officeId)?.staff?.length
		) {
			this.setState((prev) => ({ ...prev, [this.props.officeId]: true }));
			this.props.getOfficeStaff(this.props.officeId);
		}
	}

	componentDidMount() {
		this.getStaffMembers();
	}

	componentDidUpdate(prevProps) {
		if (this.props.officeId != prevProps?.officeId) {
			this.getStaffMembers();
		}
	}

	private handleEditClick() {
		if (this.props.shopcard?.shopcard?.id)
			browserHistory.push(`/shop/${this.props.shopcard?.shopcard?.id}/edit/members`);
	}

	public render() {
		const { t, shopcard, officeId, canEdit } = this.props;
		const staffMembers = shopcard.shopcard?.offices.find((office) => office.id == officeId)?.staff;

		const listProps: IItemCardList = {
			itemType: c.NODE_TYPE_STAFFPREVIEW_ITEM_CARD,
			items: (staffMembers || []).map((member) =>
				this.state.newStaffMemberData[member.id] ? { ...member, ...this.state.newStaffMemberData[member.id] } : member,
			),
			isFetching: !staffMembers,
			customProps: {
				readOnly: true,
				hideEditButton: !canEdit,
				editMember: (staffMemberData) => {
					this.props.showModal('EditStaffMemberModal', {
						initialValues: staffMemberData,
						saveImage: (image: IImageData) => this.props.cropAndSaveFormImage(image),

						onSubmitCallback: (formData) => {
							return new Promise((resolve, reject) => {
								const success = () => {
									this.setState((prev) => ({
										newStaffMemberData: { ...prev.newStaffMemberData, [staffMemberData.id]: formData },
									}));
									this.props.showNotification(this.props.t('Shop_ManageShop_ManageStaffForm_success'), 'success');
									this.props.closeModal();

									resolve(null);
								};

								if (staffMemberData.id) {
									this.props.editMember(Object.assign({}, staffMemberData, formData) as IOfficeMember, success, (e) => {
										console.error(e);
										this.props.showNotification(this.props.t('Shop_ManageShop_ManageStaffForm_error'), 'error');
										reject();
									});
								} else {
									success();
								}
							});
						},
						closeModal: this.props.closeModal,
					});
				},
				staffMemberOverview: (_id, staffMemberData) => {
					this.props.showModal('StaffMemberOverviewModal', {
						initialValues: staffMemberData,
						closeModal: this.props.closeModal,
					});
				},
			},
		};
		return (
			<>
				<dl className="d-flex d-row flex-wrap" style={{ gap: `2px` }}>
					<ItemCardList {...listProps} />
				</dl>
				{canEdit && <Button onClick={this.handleEditClick}>{t('Shop_Shopcard_Services_EditStaff')}</Button>}
			</>
		);
	}
}

export { ShopStaffMembers };
